import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'
import axios from 'axios';
import moment from 'moment';
import VueHtmlToPaper from 'vue-html-to-paper'; // ечать расписания
import createPersistedState from 'vuex-persistedstate'; // Работа vuex с LocalStorage

Object.defineProperty(Vue.prototype, '$moment', {value: moment});
require('moment/locale/ru');
moment.locale('ru');

Vue.config.productionTip = false
Vue.prototype.$axios = axios;

Vue.use(VueHtmlToPaper);



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
